import React, { useEffect } from 'react';
import "./index.scss";
import AppTool from '@utils/app-tool';

const VersionDialog = () => {

  const handleClose = () => {
    AppTool.closeDialog('.cVersionDialog')
  };

  useEffect(() => {
  }, []);

  return (
    <div className="cVersionDialog cDialogAttr" >
      <div className="cMask" onClick={() => { handleClose() }}></div>
      <div className="cDialog" >
        <img src={window.assetUrl('/images/voucher-page/popup/VersionNotes.png')}></img>
      </div>
    </div>
  )
}

export default VersionDialog;